import React from 'react';
import { Button } from 'components/Buttons';
import { CustomIcon } from 'components/CustomIcon';
import * as Styles from './ProductCard.styles';

export const FavoritesButtons: React.FC<{
  showAddToFavorites: boolean;
  isFavoritesCallback?: boolean;
  shouldAlwaysShowFavoritesButton: boolean;
  isAddToFavoritesLoading: boolean;
  right?: number;
  entityId?: string | number;
  isMobileDevice?: boolean;
  saveButtonLabel?: string;
  onClickAddToFavorites?: () => void | undefined;
}> = ({
  showAddToFavorites,
  shouldAlwaysShowFavoritesButton,
  isAddToFavoritesLoading,
  isMobileDevice = false,
  right = 16,
  entityId = undefined,
  saveButtonLabel = 'Save',
  onClickAddToFavorites,
}) => {
  const isFavoritesShown =
    showAddToFavorites ||
    shouldAlwaysShowFavoritesButton ||
    isAddToFavoritesLoading;
  const iconName = 'wishlist';
  const btnId =
    entityId != null ? `search_item_${entityId}_boards_button` : undefined;

  if (!isFavoritesShown) return null;

  return (
    <Styles.TopRightButtonsWrapper
      top={16}
      right={right}
      isMobile={isMobileDevice}
      className="card-boards-button-wrapper"
    >
      {isMobileDevice ? (
        <CustomIcon
          id={btnId}
          name={iconName}
          size={1}
          dense
          onClick={onClickAddToFavorites}
        />
      ) : (
        <Button
          id={btnId}
          onClick={onClickAddToFavorites}
          iconDense
          label={saveButtonLabel}
          size="medium"
          sx={{
            fontSize: '13px',
          }}
          color="secondary"
          variant="contained"
        />
      )}
    </Styles.TopRightButtonsWrapper>
  );
};
